import ADIColors from "@NA/Utils/ADIColors";
import React from "react";

const DoneIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.722 0C4.364 0 0 4.364 0 9.722s4.364 9.721 9.722 9.721 9.721-4.363 9.721-9.721S15.08 0 9.722 0zm4.521 7.958-5.426 5.426a.893.893 0 0 1-.633.271.893.893 0 0 1-.633-.27l-2.803-2.759a.9.9 0 0 1 0-1.288.9.9 0 0 1 1.288 0l2.125 2.124 4.793-4.792a.9.9 0 0 1 1.289 0c.34.362.34.927 0 1.288z" fill={`${ADIColors.darkBlue1}`} fillRule="nonzero" />
        </svg>
    );
};

export default React.memo(DoneIcon);
